import { useFeatureFlagEnabled } from './posthog-compat';

/**
 * Nested-sources redesign of the source control V2 popover: Clinical web uses a
 * Globe icon, "Literature and guidelines" nests under it in an IndentRail, and a
 * separator divides the clinical block from the secondary sources (My library /
 * Partner sources). Only affects the non-panel path
 * (`release-source-control-clinical-web-panel` OFF) — flag OFF restores the flat
 * layout with the Stethoscope icon. Rollout/kill gate (PostHog). Default OFF.
 */
export const useIsSourceControlNestedSourcesEnabled = () => {
  return useFeatureFlagEnabled('release-source-control-nested-sources') ?? false;
};
